module.exports = __webpack_public_path__ + "img/fastcharger-rejected-private.5684bf35.png";